import React, { useContext } from "react";
import AlertContext from "../../context/alert/alertContext";

const AlertReducer = () => {
  const alertContext = useContext(AlertContext);

  const { alert } = alertContext;

  return (
    alert !== null && (
      <div className={`gf-banner gf-banner--error`} role="alert">
        <span>{alert.msg}</span>
      </div>
    )
  );
};

export default AlertReducer;
